export default "__VITE_ASSET__C5v1uVfR__"